import type { TableHeader } from "./types";

export const SCHEDULED_DELIVERY_LIST_FILE_NAME = "ScheduledDeliveryList";

/**
 * 店舗間定期配達一覧テーブルの列定義。
 * `value` はテーブル行データの参照キーで、各列の表示値を解決するために利用する。
 */
export const TABLE_HEADERS: TableHeader[] = [
  {
    title: "出荷元店舗",
    align: "left",
    sortable: false,
    value: "shopNameFrom",
  },
  {
    title: "配達先店舗",
    align: "left",
    sortable: false,
    value: "shopNameTo",
  },
  {
    title: "配達先住所",
    align: "left",
    sortable: false,
    value: "deliveryAddress",
  },
  {
    title: "配達曜日",
    align: "center",
    sortable: false,
    value: "week",
  },
  {
    title: "便",
    align: "left",
    sortable: false,
    value: "deliveryIdName",
  },
  {
    title: "配達時間",
    align: "left",
    sortable: false,
    value: "deliveryTime",
  },
  {
    title: "除外日設定",
    align: "center",
    sortable: false,
    value: "blackoutDateSetting",
  },
  {
    title: "",
    align: "center",
    sortable: false,
    value: "actions",
  },
];
